module.exports = __webpack_public_path__ + "69974609996c59c81a87b97af16529b4.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/hannukaih-s.png
// module id = 2662
// module chunks = 0